
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Datepicker from 'element-ui/lib/date-picker';
import VeeValidate from 'vee-validate';

VeeValidate.Validator.extend("checkmx", checkmx);
VeeValidate.Validator.localize({en: {attributes: validateAttributes}});

Vue.use(Datepicker);
Vue.use(VeeValidate);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#content",
    data: vueData,
    methods: {
        formatDate: function (val) {
            if (! val) {
                return val;
            }

            return moment(val).format('GGGG-MM-DD');
        },
        hasCourses: function () {
            return this.form.courses !== null && this.form.courses.filter(function (item) {
                return item !== null && item > 0;
            }).length > 0;
        },
        validateOnSubmit: function (event) {
            var that = this;

            this.$validator.validateAll().then(function (check) {
                if (check) {
                   that.$refs.registrationForm.submit();
                } else {
                    that.$el
                        .querySelector('[name="' + that.$validator.errors.items[0].field + '"]')
                        .previousElementSibling.scrollIntoView();
                }
            });
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/form.js